<div class="chat">
  <div class="chat-messages">
    @if (groupChannel) {
      <app-chat-channel-messages-list-v2
        [groupChannel]="groupChannel"
        (markAsRead)="markAsRead()"
        (edit)="editMessage($event)">
      </app-chat-channel-messages-list-v2>
    } @else {
      <div class="chat-message-placeholder">
        <lib-skeleton-loader height="32px" width="32px" className="circle"></lib-skeleton-loader>

        <lib-skeleton-loader height="40px" width="40%"></lib-skeleton-loader>
      </div>

      <div class="chat-message-placeholder">
        <lib-skeleton-loader height="32px" width="32px" className="circle"></lib-skeleton-loader>

        <lib-skeleton-loader height="40px" width="40%"></lib-skeleton-loader>
      </div>

      <div class="chat-message-placeholder">
        <lib-skeleton-loader height="32px" width="32px" className="circle"></lib-skeleton-loader>

        <lib-skeleton-loader height="40px" width="60%"></lib-skeleton-loader>
      </div>
    }
  </div>

  <div class="chat-channel-control" [class.has-border]="!hideBorder">
    <app-chat-message-input [groupChannel]="groupChannel" (send)="sendMessage($event)" (update)="updateMessage($event)"></app-chat-message-input>
  </div>
</div>
